// Shopify locks a cart line item's price in at the moment it's added to the
// cart - editing a variant's price/compare-at price in admin afterwards has
// no effect on items already sitting in a customer's cart, so the cart (and
// what checkout charges) silently drifts out of sync with the product page.
// This checks every line against the variant's current live price whenever
// the cart drawer opens or the cart page loads, and silently re-adds any
// line that's stale (remove + add is the only way to change a line's locked
// price - the Cart API has no "update price in place").
(function () {
  let syncing = false;
  let lastSyncedAt = 0;
  const MIN_SYNC_INTERVAL_MS = 20000;

  async function getLiveVariantPrice(handle, variantId, productCache) {
    if (!productCache.has(handle)) {
      productCache.set(
        handle,
        fetch(`/products/${handle}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      );
    }
    const product = await productCache.get(handle);
    const variant = product?.variants.find((v) => v.id === variantId);
    return variant ? variant.price : null;
  }

  async function resyncLine(item) {
    await fetch(routes.cart_change_url, {
      ...fetchConfig(),
      body: JSON.stringify({ id: item.key, quantity: 0 }),
    });

    await fetch(routes.cart_add_url, {
      ...fetchConfig(),
      body: JSON.stringify({
        items: [
          {
            id: item.variant_id,
            quantity: item.quantity,
            properties: item.properties || {},
            selling_plan: item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : undefined,
          },
        ],
      }),
    });
  }

  async function syncCartPrices({ force = false } = {}) {
    if (syncing) return;
    if (!force && Date.now() - lastSyncedAt < MIN_SYNC_INTERVAL_MS) return;

    syncing = true;
    lastSyncedAt = Date.now();

    try {
      const cart = await fetch('/cart.js').then((response) => response.json());
      if (!cart.items.length) return;

      const productCache = new Map();
      let changed = false;

      // Sequential, not Promise.all - removing/re-adding lines concurrently
      // would race against each other on the same cart.
      for (const item of cart.items) {
        const livePrice = await getLiveVariantPrice(item.handle, item.variant_id, productCache);
        if (livePrice === null || livePrice === item.price) continue;

        await resyncLine(item);
        changed = true;
      }

      if (changed) {
        const updatedCart = await fetch('/cart.js').then((response) => response.json());
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-price-sync', cartData: updatedCart });
      }
    } catch (error) {
      console.error('Cart price sync failed:', error);
    } finally {
      syncing = false;
    }
  }

  window.syncCartPrices = syncCartPrices;

  document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('main-cart-items')) {
      syncCartPrices({ force: true });
    }
  });
})();
